var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPredictionModels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "prediction-models") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prediction-models",
    fill: "#132735",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29,30 L3,30 C1.346,30 0,28.654 0,27 L0,1 C0,0.447 0.447,0 1,0 C1.553,0 2,0.447 2,1 L2,27 C2,27.552 2.448,28 3,28 L29,28 C29.553,28 30,28.447 30,29 C30,29.553 29.553,30 29,30 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    transform: "translate(4.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.084,9.6 C6.242,9.238 6.599,9.003 6.993,9 C7.339,9.009 7.747,9.228 7.91,9.586 L12.175,18.969 L24.939,0.247 C24.658,0.095 24.341,0 24,0 L2,0 C0.9,0 0,0.9 0,2 L0,23.506 L6.084,9.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.826,21.563 C12.622,21.861 12.282,22.033 11.914,21.996 C11.555,21.965 11.239,21.742 11.09,21.414 L7.018,12.455 L1.173,25.814 C1.426,25.931 1.704,26 2,26 L24,26 C25.1,26 26,25.1 26,24 L26,2.242 L12.826,21.563 Z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPredictionModels);
export default __webpack_public_path__ + "static/media/prediction-models.619d20de558c4ea35b649469dc67ffb5.svg";
export { ForwardRef as ReactComponent };